import { useElapsed } from "./Stopwatch";

const TONES = { signal: "bg-[#FF4D1A] text-white", acid: "bg-[#D4FF3D] text-[#0E0E10]", ink: "bg-[#0E0E10] text-[#F1ECE2]", cobalt: "bg-[#2234F5] text-white" };

export const HeroCard = ({ big, unit, caption, tone = "signal", live, tilt = "sm:rotate-[-4deg]", testid }) => {
  const t = useElapsed();
  return (
    <div className={`w-full max-w-sm p-6 shadow-[8px_8px_0_#0E0E10] transition-transform duration-500 hover:rotate-0 sm:ml-auto sm:p-7 sm:shadow-[10px_10px_0_#0E0E10] ${TONES[tone]} ${tilt}`} data-testid={testid}>
      <p className="font-mono-x text-xs uppercase tracking-[0.2em] opacity-90">{live ? "on the clock" : unit}</p>
      <p className="font-display mt-3 text-7xl font-bold leading-none tracking-[-0.05em] sm:text-8xl">{live ? <span className="font-mono-x text-4xl tracking-normal sm:text-5xl">{t}</span> : big}</p>
      <p className="mt-4 text-[0.95rem] leading-relaxed">{caption}</p>
    </div>
  );
};
